// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-enter-active,\n.page-leave-active {\n  transition: opacity 0.5s;\n}\n\n.page-enter,\n.page-leave-to {\n  opacity: 0;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
